import front from "../../assets/n1/n1-01-front-grille-red.jpg";
import side from "../../assets/n1/n1-02-side-diffuser-panels.jpg";
import rear from "../../assets/n1/n1-03-rear-amplifier-plate.jpg";
import threeQuarter from "../../assets/n1/n1-04-three-quarter-flypoints.jpg";
import cafeBar from "../../assets/n1/n1-05-cafe-bar.jpg";
import rooftop from "../../assets/n1/n1-06-rooftop-bar-night.jpg";
import cafeStand from "../../assets/n1/n1-07-cafe-on-stand.jpg";
import chains from "../../assets/n1/n1-08-chain-mounted.jpg";

const image = (src, caption) => ({
  src,
  caption,
  alt: `SonicBeats N1 loudspeaker — ${caption.toLowerCase()}`,
});

/* Order follows the handoff: studio renders first, then the rooms. */
export const N1_STUDIO = [
  image(front, "Front view"),
  image(side, "Side panels with faceted diffuser pattern"),
  image(rear, "Rear amplifier plate (active version)"),
  image(threeQuarter, "Three-quarter view with fly points in the top panel"),
];

export const N1_LIFESTYLE = [
  image(rooftop, "Rooftop bar, evening"),
  image(cafeBar, "Stand-mounted in a café"),
  image(cafeStand, "On a stand behind the bar"),
  image(chains, "Chain-mounted above a coffee counter"),
];

export const N1_IMAGES = [...N1_STUDIO, ...N1_LIFESTYLE];

export const N1_MAIN_IMAGE = front;
export const N1_THREE_QUARTER = threeQuarter;
export const N1_ROOFTOP = rooftop;
